import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Utils } from '@app/_helpers';
import { ConfigurationService } from '@app/_shared/providers';
import { AuthService, SocialLoginProvider } from '@app/modules/auth';
import { BrokerPlanDetails } from '@app/modules/trading/modules/profile/components/plans/plans.interface';

@Component({
  selector: 'app-broker-plan-connect-broker',
  templateUrl: './broker-plan-connect-broker.component.html',
  styleUrls: ['./broker-plan-connect-broker.component.scss']
})



export class BrokerPlanConnectBrokerComponent implements OnInit {
  newAccountLink: string;
  isCancelSubscription: boolean = false;

  constructor(
    private configurationServie: ConfigurationService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public planData: BrokerPlanDetails,
    private dialogRef: MatDialogRef<BrokerPlanConnectBrokerComponent>,
  ) {
    this.isCancelSubscription = !!planData?.isCancelSubscription;
  }

  ngOnInit(): void {
  }

  openCreateNewAccount() {
    this.configurationServie.getServerConfig().subscribe((res) => {
      this.newAccountLink = res.config_params.SIGNUP_URL;
      const authLink = Utils.addParamToStringUrl(this.newAccountLink, 'REFFERAL', 'UTA1');
      window.open(authLink);
    })
  }

  loginShareIndia() {
    this.authService.initSocialLogin(SocialLoginProvider.SHARE_INDIA, true, this.planData.redirectUrl).then(pr => {
      pr.subscribe((res) => {
        const authLink = Utils.addParamToStringUrl(res.auth_link, 'REFFERAL', 'UTA1');
        location.replace(authLink);
      })
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
